import React from 'react';
import styled, { css, keyframes } from 'styled-components';

const COLORS = {
    blue:   { fg: 'var(--blue, #1e6fd9)',   bg: 'var(--blue-soft, rgba(30, 111, 217, 0.12))' },
    orange: { fg: 'var(--orange, #d9730d)', bg: 'var(--orange-soft, rgba(217, 115, 13, 0.14))' },
    red:    { fg: 'var(--red, #cf3a3a)',    bg: 'var(--red-soft, #fbe9e9)' },
    green:  { fg: 'var(--green, #1d8b5a)',  bg: 'var(--green-soft, #e3f4ec)' },
};

const pulse = keyframes`0%,100% { opacity: 1; } 50% { opacity: .35; }`;

const Wrap = styled.div`
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  max-width: 55%;
`;

const Badge = styled.span`
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  border-radius: 999px;
  padding: 5px 12px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
  ${({ $status }) => css`background: ${COLORS[$status].bg}; color: ${COLORS[$status].fg};`}
  &::before {
    content: '●';
    font-size: 8px;
    ${({ $status }) => $status !== 'green' && css`animation: ${pulse} 2s infinite;`}
  }
`;

const Periods = styled.span`
  font-size: 12px;
  font-weight: 700;
  text-align: right;
  line-height: 1.3;
  color: ${({ $status }) => COLORS[$status].fg};
`;

const LegendWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px 14px;
  font-size: 12px;
  color: var(--text-muted);
  margin: 2px 0 6px;
  span { display: inline-flex; align-items: center; gap: 5px; }
  i { width: 9px; height: 9px; border-radius: 50%; display: inline-block; }
`;

/** Selo do diário + períodos em aberto (usa o retorno de statusDiarioTurma). */
export function DiaryStatus({ status = 'green', texto = '' }) {
    const aberto = status !== 'green';
    return (
        <Wrap>
            <Badge $status={status}>{aberto ? 'Diário em aberto' : 'Diários fechados'}</Badge>
            {aberto && texto && <Periods $status={status} title={`Em aberto: ${texto}`}>{texto}</Periods>}
        </Wrap>
    );
}

export function DiaryLegend() {
    return (
        <LegendWrap>
            <span><i style={{ background: COLORS.blue.fg }} /> Em dia</span>
            <span><i style={{ background: COLORS.orange.fg }} /> Período anterior aberto</span>
            <span><i style={{ background: COLORS.red.fg }} /> 1º período ainda aberto no último</span>
            <span><i style={{ background: COLORS.green.fg }} /> Diários fechados</span>
        </LegendWrap>
    );
}

export default DiaryStatus;
